import { render, staticRenderFns } from "./Bolsa.vue?vue&type=template&id=d24355a6"
import script from "./Bolsa.vue?vue&type=script&lang=js"
export * from "./Bolsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports